interface ICountBadgeProps {
  counts: number;
}

/**
 * -----------------------------------------------------------------------------
 * It renders a badge with a number inside.
 */
export function CountBadge({ counts }: Readonly<ICountBadgeProps>) {
  return (
    <div
      className="
        flex min-h-6 min-w-6 items-center justify-center rounded-full
        bg-green-200 text-xs font-normal
      "
    >
      {counts}
    </div>
  );
}
